let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3i6w8")).then(() => parcelRequire('9EcbH'));